import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi) // Load translations via HTTP
  .use(LanguageDetector) // Detect language from browser
  .use(initReactI18next) // Bind React to i18next
  .init({
    supportedLngs: ["en", "bn", "hi"], // Supported languages
    fallbackLng: "en", // Default language
    debug: false, // Enable debugging in development
    interpolation: {
      escapeValue: false, // React already escapes output
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // Translation files path
    },
    detection: {
      order: ["localStorage", "navigator"], // Detect language from localStorage or browser
      caches: ["localStorage"], // Store selected language
    },
  });

export default i18n;
